
@switch (columnId) {
  @case (FundingInstructionsOrderBy.MID) {
    <lib-text-table-column>
      {{ element.mid }}
    </lib-text-table-column>
  }
  @case (FundingInstructionsOrderBy.DateCreated) {
    <lib-date-time-label [dateUtc]="element.dateCreated"></lib-date-time-label>
  }
  @case ('vituPayDepositAmount') {
    <lib-text-table-column>
      {{ element.vituPayDepositAmount | vituCurrencyUsd }}
    </lib-text-table-column>
  }
  @case ('merchantDepositAmount') {
    <lib-text-table-column>
      {{ element.merchantDepositAmount | vituCurrencyUsd }}
    </lib-text-table-column>
  }
  @case (FundingInstructionsOrderBy.FundingStatus) {
    <lib-funding-item-status-chip
      [status]="element.fundingStatus">
    </lib-funding-item-status-chip>
  }
  @case (FundingInstructionsOrderBy.DateFunded) {
    <lib-date-time-label [dateUtc]="element.dateFunded"></lib-date-time-label>
  }
  @default {
  }
}
